module.exports = __webpack_public_path__ + "static/Grill_Pavilion-a61b32d88b11885c2ecb089b97c4f8c3.jpg";